
namespace Gamification.Gamification {
    export class RaccomandazioniColumns {
        static columnsKey = 'Gamification.Raccomandazioni';
    }
}